/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import Layoutcursos from "../../Layout/Cursoslayout";

const Pacientesespeciais = () => {
    return(
        <>
            <Layoutcursos>   
            </Layoutcursos>
            <img src="/images/professores/aquiladantas.jpg" className="img-endodontia" alt="professor"></img>
                <div className="conteudopublico">
                    <p> CIRURGIÕES-DENTISTAS </p>
                </div>
                <div className="conteudodiferenciais">
                    <p>- IMERSÃO EM SEDAÇÃO MULTIMODAL<br/>
                           - ESTÁGIO SUPERVISIONADO EM HOSPITAL <br/>
                           - ESTÁGIO SUPERVISIONADO EM INSTITUTO DE LONGA PERMANÊNCIA
                    </p>
                    
                </div>
                <div className="professor">
                    <p id="prof">PROFª.</p><br/>
                    <strong id="coordenacao">Áquila Dantas </strong><br/><br/>
                    <p className="curriculo">Graduada Odontologia (UFRN) 
                                                    Especialista em Saúde da Família (FACISA/PB)
                                                    Especialista em Odontologia para Pacientes com Necessidades Especiais (COESP/PB)
                                                    Mestrado em Ciências da Saúde (UNICSUL/SP)
                                                    Pós Graduação em Saúde Mental (UFCG/PB)
                                                    Presidente da Câmara Técnica de Pacientes Especiais do Conselho Regional de Odontologia (CRO/RN)
                                                    Acadêmica Fundadora e Vitalícia da Academia Interamericana de Odontologia para Pacientes Especiais (AIOPE) 
                                                    Coordenadora da Qualificação em atendimento odontológico sob anestesia geral à criança com deficiência no Hospital Pediátrico Maria Alice Fernandes 
                                                    Funcionária da Prefeitura de Natal e Assu, atendendo no Centro de Especialidade Odontológico ( CEO) como especialista em pacientes especiais nas referidas cidades</p>

                    <br/> <div className="convidados">
                    <strong>CONVIDADOS</strong><br/>                                
                    <details>
                        <small>
                        
                        </small>
                    </details>
                    </div><br/>
                    <div className="professores">
                        <strong>PROFESSORES</strong><br/>                                
                        <details>
                            {/* <summary> PROFESSORES </summary> */}
                            <small>
                            Maria Cecília Azevedo de Aguiar<br/>
                            Anna Lucy de Castro Sobral<br/>
                            João Epaminondas Silva de Araújo<br/>
                            Glória Maria Pimenta Cabral
                            </small>
                        </details><br/><br/> 
                    </div> 

                </div>
                <div id="tipodepagamento">
                    <p className="encontro-conteudo">MENSALMENTE | QUARTA A SÁBADO</p>
                    {/* <small className="encontro-horarios">8H ÀS 12H E DAS 13H30 DAS 17H30</small> */}
                    <p className="cargahoraria-conteudo">1000 HORAS</p>
                    <p className="tipoaula-conteudo">PRESENCIAL </p>
                    <p className="parcelas">24X</p>
                    <p className="R">R$</p>
                    <h1 className="valor">1.350,00</h1>
                    <p className="pagamento-info">PAGAMENTO NO CARTÃO OU NO BOLETO ATÉ A DATA DO VENCIMENTO</p>
                </div>
                <div>
                    <strong className="titulo-curso">ESPECIALIZAÇÃO EM ODONTOLOGIA PARA PACIENTES COM NECESSIDADES ESPECIAIS</strong>   
                </div>
                <div className="conteudo-curso">
                    <p>
                    A Especialização em Odontologia para Pacientes com Necessidades Especiais (OPNE) tem como objetivo o diagnóstico, a prevenção, o tratamento e o controle dos problemas bucais de pessoas que apresentam complexidade biopsicossocial. Trata-se, portanto, de uma área específica de conhecimento exercida por um profissional qualificado a executar procedimentos de maior complexidade, buscando a eficácia e a eficiência de suas ações sob uma visão multidisciplinar.
                    Na Especialização em OPNE da UNIFACEX será ofertado estágios supervisionamos em hospitais para o atendimento odontológico sob anestesia geral, estágios supervisionados em Instituições de Longa Permanência para Idosos, laserterapia e imersão em sedação multimodal.
                    O aluno da Especialização em OPNE será capacitado para oferecer atendimento ao paciente com necessidades especiais aplicando conhecimento técnico-científico, os quais permitem o tratamento odontológico sob uma visão multidisciplinar.  Buscamos, também, atualizar e oferecer aos nossos alunos técnicas para que estes desenvolvam habilidades  para avaliar, planejar e executar o tratamento odontológico de forma integrada e holística. 
                    Ao final, almejamos que nossos alunos estejam aptos a realizar atendimento odontológico desses pacientes, em níveis crescentes de complexidade, nos ambientes ambulatorial (consultório), domiciliar e hospitalar.
                    Venha conosco nessa jornada na busca pelo seu crescimento profissional.
                    Invista em você !!!</p>
                </div>
                <a href={`${process.env.PUBLIC_URL}/Files/pdf/Matriz-OdontologiaPNE.pdf`} rel="noreferrer" target='_blank' download><button className="Matriz" ><h4>MATRIZ CURRICULAR</h4></button></a>
     
        </>
    )
};

export default Pacientesespeciais;